<template>
  <div class="content-wrap">
    <div class="page-title" v-if="title != null">
      <span class="back-button pointer" @click="goBack()" v-if="backButton">
        <material-icon name="arrow_back" size="23" />
      </span>
      <span class="title">{{ title }}</span>
    </div>
    <div :class="['content', { 'with-margin': withMargin }]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "layout-content",
  props: {
    title: {
      type: String,
      default: null,
    },
    backButton: {
      type: [Boolean, Object],
      default: false,
    },
    withMargin: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goBack: function () {
      if (typeof this.backButton === "object") {
        this.$router.push(this.backButton);
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
